 ///home/clement/compta-app/client/src/components/Facturation/SuiviPaiements.js
 
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Chip
} from '@mui/material';
import { fetchPaiements, marquerCommePaye, relancerClient } from '../../api/paiementApi';

const SuiviPaiements = () => {
  const [paiements, setPaiements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filtreStatut, setFiltreStatut] = useState('tous');
  const [filtreClient, setFiltreClient] = useState('');
  const [clients, setClients] = useState([]);

  // Chargement des paiements et des clients
  useEffect(() => {
    const loadData = async () => {
      try {
        const [paiementsData, clientsData] = await Promise.all([
          fetchPaiements(),
          fetch('/api/clients').then(res => res.json())
        ]);
        setPaiements(paiementsData);
        setClients(clientsData);
      } catch (err) {
        setError("Erreur lors du chargement des données.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  // Filtrer les paiements selon les critères
  const paiementsFiltres = paiements.filter(p => {
    const statutOk = filtreStatut === 'tous' || p.statut === filtreStatut;
    const clientOk = !filtreClient || p.clientId === filtreClient;
    return statutOk && clientOk;
  });

  // Actions sur les paiements
  const handleMarquerCommePaye = async (id) => {
    try {
      await marquerCommePaye(id);
      setPaiements(paiements.map(p => p.id === id ? {...p, statut: 'payé'} : p));
    } catch (err) {
      console.error("Erreur lors de la mise à jour du paiement:", err);
    }
  };

  const handleRelancerClient = async (id) => {
    try {
      await relancerClient(id);
      alert(`Relance envoyée pour le paiement ${id}`);
    } catch (err) {
      console.error("Erreur lors de l'envoi de la relance:", err);
    }
  };

  if (loading) return <CircularProgress />;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Suivi des Paiements
      </Typography>

      {/* Filtres */}
      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Statut</InputLabel>
          <Select
            value={filtreStatut}
            onChange={(e) => setFiltreStatut(e.target.value)}
          >
            <MenuItem value="tous">Tous</MenuItem>
            <MenuItem value="en attente">En attente</MenuItem>
            <MenuItem value="partiel">Partiel</MenuItem>
            <MenuItem value="payé">Payé</MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Client</InputLabel>
          <Select
            value={filtreClient}
            onChange={(e) => setFiltreClient(e.target.value)}
          >
            <MenuItem value="">Tous</MenuItem>
            {clients.map(client => (
              <MenuItem key={client.id} value={client.id}>{client.nom}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {/* Tableau des paiements */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Référence</TableCell>
              <TableCell>Client</TableCell>
              <TableCell>Montant (€)</TableCell>
              <TableCell>Date d'échéance</TableCell>
              <TableCell>Statut</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paiementsFiltres.map((paiement) => (
              <TableRow key={paiement.id}>
                <TableCell>{paiement.reference}</TableCell>
                <TableCell>{paiement.clientNom}</TableCell>
                <TableCell>{paiement.montant.toFixed(2)}</TableCell>
                <TableCell>{new Date(paiement.dateEcheance).toLocaleDateString()}</TableCell>
                <TableCell>
                  <Chip
                    label={paiement.statut}
                    color={
                      paiement.statut === 'payé' ? 'success' :
                      paiement.statut === 'partiel' ? 'warning' : 'error'
                    }
                  />
                </TableCell>
                <TableCell>
                  {paiement.statut !== 'payé' && (
                    <>
                      <Button
                        variant="outlined"
                        color="success"
                        size="small"
                        onClick={() => handleMarquerCommePaye(paiement.id)}
                      >
                        Marquer comme payé
                      </Button>
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        sx={{ ml: 1 }}
                        onClick={() => handleRelancerClient(paiement.id)}
                      >
                        Relancer
                      </Button>
                    </>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SuiviPaiements;

